module.exports = __webpack_public_path__ + "static/media/tachometer-slow.12b3c3b7.svg";